module.exports = __webpack_public_path__ + "img/cnu_gallery2.b8419847.jpg";